import React from 'react';
import { useStyles } from './styles';
const BaseList = ({ emptyMsg, children }) => {
    const ownClasses = useStyles();
    return (React.createElement(React.Fragment, null, React.Children.toArray(children).length ? (React.createElement("ul", null, children)) : (React.createElement("p", { className: ownClasses.emptyMsg }, emptyMsg))));
};
export default BaseList;
